// Primary 4 Mathematics Data - 小學四年級數學數據
export const p4MathsData = {
  title: '小學四年級數學',
  description: '深入學習數學概念，掌握更複雜的運算技能',
  grade: 'P4',
  year: '小學四年級',
  
  topics: [
    {
      id: 'p4-4n1',
      code: '4N1',
      title: '多位數',
      description: '認識多位數，理解數位概念',
      objectives: [
        '認識100000以上的數字',
        '理解各數位的概念',
        '學會讀寫多位數',
        '比較多位數的大小'
      ],
      sampleQuestions: [
        {
          id: 'p4-4n1-q1',
          question: '寫出數字：十二萬三千四百五十六',
          answer: '123456',
          solution: '十二萬三千四百五十六 = 120000 + 3000 + 400 + 50 + 6 = 123456',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n1-q2',
          question: '讀出數字：789012',
          answer: '七十八萬九千零一十二',
          solution: '789012 = 700000 + 80000 + 9000 + 0 + 10 + 2',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n1-q3',
          question: '比較大小：123456 和 124356',
          answer: '123456 < 124356',
          solution: '比較千位：3 < 4，所以123456 < 124356',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n1-q4',
          question: '在100000到200000之間有多少個數字？',
          answer: '99999個',
          solution: '100000到200000之間的數字是：100001, 100002, ..., 199999，共99999個。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n1-q5',
          question: '寫出比999999大1的數字。',
          answer: '1000000',
          solution: '999999 + 1 = 1000000\n999999加1後變成1000000，這是一個七位數。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4n2',
      code: '4N2',
      title: '加法和減法(五)',
      description: '學習多位數的加減法運算',
      objectives: [
        '學會多位數的加法',
        '學會多位數的減法',
        '理解多位數的進位和退位',
        '解決多位數的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p4-4n2-q1',
          question: '計算：123456 + 789012 = ?',
          answer: '912468',
          solution: '123456 + 789012 = 912468\n按位相加，注意進位。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n2-q2',
          question: '計算：456789 - 234567 = ?',
          answer: '222222',
          solution: '456789 - 234567 = 222222\n按位相減，注意退位。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n2-q3',
          question: '小明有345678元，買了一台電腦花了234567元，還剩下多少元？',
          answer: '111111元',
          solution: '345678 - 234567 = 111111\n小明原本有345678元，花了234567元，所以還剩下111111元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n2-q4',
          question: '計算：123456 + 234567 + 345678 = ?',
          answer: '703701',
          solution: '123456 + 234567 + 345678 = 703701\n先算：123456 + 234567 = 358023\n再算：358023 + 345678 = 703701',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n2-q5',
          question: '小華有567890個糖果，給了小明234567個，又給了小紅123456個，還剩下多少個？',
          answer: '209867個',
          solution: '567890 - 234567 - 123456 = 209867\n先算：567890 - 234567 = 333323\n再算：333323 - 123456 = 209867',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4n3',
      code: '4N3',
      title: '乘法(三)',
      description: '學習多位數的乘法運算',
      objectives: [
        '學會兩位數乘以兩位數',
        '學會三位數乘以兩位數',
        '理解乘法的進位概念',
        '解決乘法應用題'
      ],
      sampleQuestions: [
        {
          id: 'p4-4n3-q1',
          question: '計算：23 × 45 = ?',
          answer: '1035',
          solution: '23 × 45 = 1035\n23 × 40 = 920\n23 × 5 = 115\n920 + 115 = 1035',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n3-q2',
          question: '計算：156 × 78 = ?',
          answer: '12168',
          solution: '156 × 78 = 12168\n156 × 70 = 10920\n156 × 8 = 1248\n10920 + 1248 = 12168',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n3-q3',
          question: '小明有25個盒子，每個盒子有36個蘋果，一共有多少個蘋果？',
          answer: '900個',
          solution: '25 × 36 = 900\n25個盒子，每個盒子36個蘋果，所以一共有900個蘋果。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n3-q4',
          question: '計算：234 × 67 = ?',
          answer: '15678',
          solution: '234 × 67 = 15678\n234 × 60 = 14040\n234 × 7 = 1638\n14040 + 1638 = 15678',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n3-q5',
          question: '小華有18排椅子，每排有25張椅子，一共有多少張椅子？',
          answer: '450張',
          solution: '18 × 25 = 450\n18排椅子，每排25張，所以一共有450張椅子。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4n4',
      code: '4N4',
      title: '除法(三)',
      description: '學習多位數的除法運算',
      objectives: [
        '學會三位數除以兩位數',
        '學會四位數除以兩位數',
        '理解除法的餘數概念',
        '解決除法應用題'
      ],
      sampleQuestions: [
        {
          id: 'p4-4n4-q1',
          question: '計算：156 ÷ 12 = ?',
          answer: '13',
          solution: '156 ÷ 12 = 13\n可以用乘法驗證：12 × 13 = 156',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n4-q2',
          question: '計算：2340 ÷ 15 = ?',
          answer: '156',
          solution: '2340 ÷ 15 = 156\n可以用乘法驗證：15 × 156 = 2340',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n4-q3',
          question: '小明有156個蘋果，要分給12個小朋友，每人分到多少個？',
          answer: '13個',
          solution: '156 ÷ 12 = 13\n156個蘋果分給12個小朋友，每人分到13個蘋果。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n4-q4',
          question: '計算：3456 ÷ 24 = ?',
          answer: '144',
          solution: '3456 ÷ 24 = 144\n可以用乘法驗證：24 × 144 = 3456',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n4-q5',
          question: '小華有2340個糖果，要裝在15個盒子裡，每個盒子裝多少個？',
          answer: '156個',
          solution: '2340 ÷ 15 = 156\n2340個糖果裝在15個盒子裡，每個盒子裝156個糖果。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4n5',
      code: '4N5',
      title: '分數(二)',
      description: '進一步學習分數概念',
      objectives: [
        '學會分數的加減法',
        '學會分數的比較',
        '理解分數的約分',
        '解決分數應用題'
      ],
      sampleQuestions: [
        {
          id: 'p4-4n5-q1',
          question: '計算：1/3 + 2/3 = ?',
          answer: '1',
          solution: '1/3 + 2/3 = 3/3 = 1\n分母相同時，分子相加。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n5-q2',
          question: '計算：3/4 - 1/4 = ?',
          answer: '1/2',
          solution: '3/4 - 1/4 = 2/4 = 1/2\n分母相同時，分子相減。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4n5-q3',
          question: '比較大小：2/3 和 3/4',
          answer: '3/4 > 2/3',
          solution: '通分後比較：2/3 = 8/12，3/4 = 9/12\n9/12 > 8/12，所以3/4 > 2/3',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n5-q4',
          question: '小明有1/2個蛋糕，小華有1/3個蛋糕，兩人一共有多少個蛋糕？',
          answer: '5/6個',
          solution: '1/2 + 1/3 = 3/6 + 2/6 = 5/6\n通分後相加。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4n5-q5',
          question: '小華有3/4個蘋果，吃了1/4個，還剩下多少？',
          answer: '1/2個',
          solution: '3/4 - 1/4 = 2/4 = 1/2\n還剩下1/2個蘋果。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4m1',
      code: '4M1',
      title: '面積',
      description: '認識面積的概念和計算',
      objectives: [
        '認識面積的概念',
        '學會計算正方形和長方形的面積',
        '理解面積的單位',
        '解決面積相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p4-4m1-q1',
          question: '正方形的面積公式是什麼？',
          answer: '邊長 × 邊長',
          solution: '正方形的面積 = 邊長 × 邊長\n或寫作：面積 = 邊長²',
          difficulty: 'basic'
        },
        {
          id: 'p4-4m1-q2',
          question: '長方形的面積公式是什麼？',
          answer: '長 × 寬',
          solution: '長方形的面積 = 長 × 寬',
          difficulty: 'basic'
        },
        {
          id: 'p4-4m1-q3',
          question: '一個正方形的邊長是5厘米，面積是多少？',
          answer: '25平方厘米',
          solution: '5 × 5 = 25\n正方形的面積是25平方厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4m1-q4',
          question: '一個長方形的長是8厘米，寬是6厘米，面積是多少？',
          answer: '48平方厘米',
          solution: '8 × 6 = 48\n長方形的面積是48平方厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4m1-q5',
          question: '一個長方形的面積是60平方厘米，長是10厘米，寬是多少？',
          answer: '6厘米',
          solution: '60 ÷ 10 = 6\n長方形的寬是6厘米。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4m2',
      code: '4M2',
      title: '周長',
      description: '認識周長的概念和計算',
      objectives: [
        '認識周長的概念',
        '學會計算正方形和長方形的周長',
        '理解周長的單位',
        '解決周長相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p4-4m2-q1',
          question: '正方形的周長公式是什麼？',
          answer: '4 × 邊長',
          solution: '正方形的周長 = 4 × 邊長',
          difficulty: 'basic'
        },
        {
          id: 'p4-4m2-q2',
          question: '長方形的周長公式是什麼？',
          answer: '2 × (長 + 寬)',
          solution: '長方形的周長 = 2 × (長 + 寬)',
          difficulty: 'basic'
        },
        {
          id: 'p4-4m2-q3',
          question: '一個正方形的邊長是6厘米，周長是多少？',
          answer: '24厘米',
          solution: '4 × 6 = 24\n正方形的周長是24厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4m2-q4',
          question: '一個長方形的長是10厘米，寬是6厘米，周長是多少？',
          answer: '32厘米',
          solution: '2 × (10 + 6) = 2 × 16 = 32\n長方形的周長是32厘米。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4m2-q5',
          question: '一個長方形的周長是24厘米，長是8厘米，寬是多少？',
          answer: '4厘米',
          solution: '24 ÷ 2 = 12\n12 - 8 = 4\n長方形的寬是4厘米。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4s1',
      code: '4S1',
      title: '對稱',
      description: '認識對稱的概念',
      objectives: [
        '認識對稱的概念',
        '學會識別對稱圖形',
        '理解對稱軸的概念',
        '學會簡單的對稱圖形繪製'
      ],
      sampleQuestions: [
        {
          id: 'p4-4s1-q1',
          question: '什麼是對稱軸？',
          answer: '將圖形分成兩部分相等的直線',
          solution: '對稱軸是將圖形分成兩部分相等的直線。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4s1-q2',
          question: '正方形有多少條對稱軸？',
          answer: '4條',
          solution: '正方形有4條對稱軸：2條對角線和2條中線。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4s1-q3',
          question: '長方形有多少條對稱軸？',
          answer: '2條',
          solution: '長方形有2條對稱軸：2條中線。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4s1-q4',
          question: '等邊三角形有多少條對稱軸？',
          answer: '3條',
          solution: '等邊三角形有3條對稱軸：3條高線。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4s1-q5',
          question: '圓形有多少條對稱軸？',
          answer: '無數條',
          solution: '圓形有無數條對稱軸：任何通過圓心的直線都是對稱軸。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4s2',
      code: '4S2',
      title: '角度',
      description: '認識角度的概念和測量',
      objectives: [
        '認識角度的概念',
        '學會用角度器測量角度',
        '理解不同類型角度的概念',
        '學會簡單的角度計算'
      ],
      sampleQuestions: [
        {
          id: 'p4-4s2-q1',
          question: '直角是多少度？',
          answer: '90度',
          solution: '直角是90度。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4s2-q2',
          question: '平角是多少度？',
          answer: '180度',
          solution: '平角是180度。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4s2-q3',
          question: '周角是多少度？',
          answer: '360度',
          solution: '周角是360度。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4s2-q4',
          question: '一個三角形的三個角分別是60度、60度、60度，這是什麼三角形？',
          answer: '等邊三角形',
          solution: '三個角都是60度，所以是等邊三角形。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4s2-q5',
          question: '一個四邊形的四個角都是90度，這是什麼四邊形？',
          answer: '長方形或正方形',
          solution: '四個角都是90度的四邊形是長方形或正方形。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4d1',
      code: '4D1',
      title: '折線圖',
      description: '認識折線圖的基本概念',
      objectives: [
        '認識折線圖的概念',
        '學會讀取折線圖的數據',
        '理解折線圖的用途',
        '學會簡單的數據分析'
      ],
      sampleQuestions: [
        {
          id: 'p4-4d1-q1',
          question: '折線圖中，線的上升表示什麼？',
          answer: '數量增加',
          solution: '折線圖中，線的上升表示數量增加。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4d1-q2',
          question: '折線圖中，線的下降表示什麼？',
          answer: '數量減少',
          solution: '折線圖中，線的下降表示數量減少。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4d1-q3',
          question: '如果折線圖顯示溫度從20度上升到25度，溫度變化了多少？',
          answer: '上升了5度',
          solution: '25 - 20 = 5\n溫度上升了5度。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4d1-q4',
          question: '折線圖顯示某商品價格從100元下降到80元，價格變化了多少？',
          answer: '下降了20元',
          solution: '100 - 80 = 20\n價格下降了20元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4d1-q5',
          question: '折線圖顯示某班級人數從30人增加到35人，又減少到32人，最終人數變化了多少？',
          answer: '增加了2人',
          solution: '32 - 30 = 2\n最終人數增加了2人。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p4-4f1',
      code: '4F1',
      title: '探索與研究',
      description: '通過活動發現數學規律',
      objectives: [
        '培養數學思維能力',
        '學會觀察和發現規律',
        '提高解決問題的能力',
        '培養探索精神'
      ],
      sampleQuestions: [
        {
          id: 'p4-4f1-q1',
          question: '觀察數字：5, 10, 15, 20, 25，下一個數字是什麼？',
          answer: '30',
          solution: '每個數字都比前一個多5，所以下一個是25 + 5 = 30。',
          difficulty: 'basic'
        },
        {
          id: 'p4-4f1-q2',
          question: '用16個相同的正方形可以拼成什麼圖形？',
          answer: '正方形',
          solution: '16個正方形可以拼成一個大正方形，4×4的排列。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4f1-q3',
          question: '小明有20個蘋果，每次吃4個，可以吃幾天？',
          answer: '5天',
          solution: '20 ÷ 4 = 5\n20個蘋果，每天吃4個，可以吃5天。',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4f1-q4',
          question: '找出規律：1, 4, 9, 16, ?',
          answer: '25',
          solution: '每個數字都是位置數的平方：1²=1, 2²=4, 3²=9, 4²=16, 5²=25',
          difficulty: 'intermediate'
        },
        {
          id: 'p4-4f1-q5',
          question: '用12根相同長度的木棒可以拼成什麼圖形？',
          answer: '正十二邊形',
          solution: '12根相同長度的木棒可以拼成正十二邊形。',
          difficulty: 'advanced'
        }
      ]
    }
  ]
}; 